import React, { useContext } from "react";
import {
  formatPhoneNumber,
  numberToWords,
  formatPrice,
  invoiceCalculate,
} from "../../../utils/Common";
import Watermark from "../Watermark/Watermark";
import "./PdfHtmlContent.css";
import "./PdfHrmlContentPad.css";
import { AppContext } from "../../../context/context.js";

import QRCode from "react-qr-code";
import ImageUploader3 from "../../ImageUploader3";
import classNames from "classnames";
import PdfHtmlContentPad from "./PdfHtmlContentPad.js";
import PdfHtmlContentPadCustomize from "./PdfHtmlContentPadCustomize.js";
import PdfHtmlContentCustomize from "./PdfHtmlContentCustomize.js";
import PdfHtmlContentCustomizeWithoutColor from "./PdfHtmlContentCustomizeWithoutColor.js";
import PdfHtmlContentToken from "./PdfHtmlContentToken.js";
import PdfHtmlContentBrandNew from "./PdfHtmlContentBrandNew.jsx";

const PdfHtmlContent = (props) => {
  const {
    invoice,
    invoiceSetting,
    id,
    parentClassName,
    invoiceImeis,
    inputs,
    exChangeImeis,
  } = props;
  console.log(exChangeImeis);
  const { state, isLoading, updateInvoiceList } = useContext(AppContext);
  const userInfo = invoice.user_info;
  const BASE_URL = process.env.REACT_APP_ROOT_URL;
  const invoiceDate = new Date(invoice.created_at);
  const year = invoiceDate.getFullYear();
  const month = String(invoiceDate.getMonth() + 1).padStart(2, "0");
  const day = String(invoiceDate.getDate()).padStart(2, "0");
  const hours = String(invoiceDate.getHours() % 12).padStart(2, "0");
  const minutes = String(invoiceDate.getMinutes()).padStart(2, "0");
  const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM";
  const shop_logo = invoiceSetting?.shop_logo
    ? invoiceSetting?.shop_logo
    : `${BASE_URL}/layoutlogo.svg`;
  const formattedDate = `${year}-${month}-${day}`;
  const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`;
  const processedInvoiceIds = new Set();
  const processedProductIds = new Set(); // To track processed product_ids
  const imeisByProduct = [];
  const user = JSON.parse(localStorage.getItem("user"));

  // Aggregate unique IMEIs with all details
  invoiceImeis.forEach((imei) => {
    const imeiValue = imei.imei.toString().trim(); // Normalize the IMEI

    // Check if the IMEI already exists in imeisByProduct
    const imeiExists = imeisByProduct.some(
      (imeiDetail) => imeiDetail.imei === imeiValue
    );

    if (!imeiExists) {
      // If the IMEI doesn't exist, add it to imeisByProduct
      imeisByProduct.push({
        product_id: imei.product_id,
        product_name: imei.product_name,
        imei: imei.imei,
        sale_price: imei.sale_price,
        purchase_price: imei.purchase_price,
        base_currency_code: imei.base_currency_code,
        currency_rate: imei.currency_rate,
        purchase_currency_code: imei.purchase_currency_code,
      });
    }
  });

  console.log("Imeis in Invoices........ ",invoiceImeis)

  let totalQty = 0;
  let totalItems = 0;
  let totalPrice = 0;
  let grandTotal = totalPrice + 0;

  let totalQtyPrint = 0;
  let totalItemsPrint = 0;
  let totalPricePrint = 0;

  let totalItemsPrintPad = 0;
  let totalPricePrintPad = 0;

  let totalItemsPrintCustomize = 0;
  let totalPricePrintCustomize = 0;

  let grandTotalValue = invoice?.sales_details?.product_info?.reduce(
    (sum, product) => {
      const imeisArray = invoiceImeis?.filter(
        (imei) => imei.product_id === product.product_id
      );
      if (imeisArray?.length) {
        const qty = imeisArray.length;
        sum + qty * imeisArray[0].sale_price;
      } else {
        sum + product.qty * product.price;
      }
      return sum;
    },
    0
  );

  console.log(invoice);

  const totalDuePayment = invoice?.multiple_payment
    ?.filter((p) => p.invoice_id?.includes("INV-DUE"))
    ?.reduce((sum, p) => sum + Number(p.payment_amount), 0) || 0;

  return (
    // new invoice
    <>
      <div className="pdfConentAreas">
        {console.log("invoice ", invoice)}
        {console.log("invoiceSetting ", invoiceSetting)}
        <div
          id="invoice-detail-page"
          className="invoice-detail-page font-nunito mx-12 sm:mx-0"
        >
          {/* invoice header */}
          {/* <div className="text-center text-xs md:text-sm lg:text-base">
          <div>

            <img src={shop_logo} alt={invoice.invoice_id} className={parentClassName + ' mx-auto w-1/2 md-[5px] max-w-[220px]'} />

            <div className=' leading-4 sm:leading-5 md:leading-6 mt-[5px] font-normal'>
              {userInfo?.outlet_name &&
                <p className='capitalize text-[22px] font-semibold'>{userInfo?.outlet_name} </p>
              }
              {userInfo?.address &&
                <p>{userInfo?.address}</p>
              }
              {invoiceSetting?.mobile_number &&
                <p>{formatPhoneNumber(invoiceSetting?.mobile_number, invoice?.user_info?.country_code)}</p>
              }
            <div className='flex flex-col '>
           <span>{invoiceSetting?.web_address ?
              invoiceSetting?.web_address
            : (
              ""
            )}</span>
            <span>
            {invoiceSetting?.social_link ?
              invoiceSetting?.social_link
            : (
              ""
            )}
            </span>

            </div>

            </div>
          </div>
        </div> */}
          {/* invoice header */}
          <div
            className="flex flex-col md:flex-row justify-between items-center pt-4 pb-1 border-b-4 "
            style={{
              borderColor: invoiceSetting?.dummy_text
                ? invoiceSetting?.dummy_text
                : "#93C5FD",
            }}
          >
            {/* Shop Logo Section */}
            <div className="w-1/3 flex flex-col justify-start md:items-start items-center">
              <img
                src={invoiceSetting?.shop_logo}
                alt="Shop Logo"
                className="w-[50px] sm:w-[70px] md:w-[90px] object-contain"
              />
              <p className="mt-2">
                {" "}
                {/* Adds some spacing between image and text */}
                <span
                  className="font-semibold text-lg"
                  style={{ letterSpacing: "0.08em" }}
                >
                  Sale Invoice
                </span>
              </p>
            </div>

            {/* QR Code Section */}
            <div className="w-1/3 flex justify-center pb-2">
              <div className="w-[45px] sm:w-[65px] md:w-[100px]">
                <QRCode
                  className="w-full object-contain"
                  value={BASE_URL + "/invoice-view/" + invoice?.invoice_id}
                  size={100}
                />
              </div>
            </div>

            {/* Shop Info Section */}
            <div className="md:w-1/3 flex flex-col justify-end items-center md:items-start">
              <span
                className="font-semibold text-lg sm:text-xl md:text-2xl mb-2"
                style={{ letterSpacing: "0.08em" }}
              >
                {invoiceSetting?.shop_name}
              </span>
              <span className="text-sm sm:text-md text-gray-600">
                <strong>Phone:</strong> {invoiceSetting?.mobile_number}
              </span>
              <span className="text-sm sm:text-md text-gray-600">
                <strong>Email:</strong> {invoice?.user_info?.email}
              </span>
              <span className="text-xs sm:text-md text-gray-600">
                <strong>Address:</strong> {userInfo?.address}
              </span>
            </div>
          </div>
          {/* customer info and QR */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center mt-[10px] justify-between gap-2 sm:gap-0 pl-8 sm:pl-0">
            <div className="text-black space-y-[2px] md:space-y-[6px] font-nunito text-xs lg:text-base">
              {/* <p> <span className='font-semibold'>Customer Name</span>  :  {invoice.customer_name} </p>
            <p><span className='font-semibold'>Customer Phone</span> :  {invoice.country_code}{invoice.customer_phone}</p>
            <p><span className='font-semibold'> Customer ID </span> :#{invoice.customer_id}</p>
            <p><span className='font-semibold'> Invoice Date </span>: {formattedDateTime} </p> */}
              <p>
                {" "}
                <span className="font-semibold">Bill to,</span> <br />{" "}
                <span className="font-semibold">Customer Name </span> :{" "}
                {invoice?.delivery_customer_name
                  ? invoice?.delivery_customer_name
                  : invoice?.customer_name}{" "}
              </p>
              <p>
                <span className="font-semibold">Customer Phone</span> :{" "}
                {invoice.country_code}
                {invoice.customer_phone || invoice.delivery_customer_phone}
              </p>
              <p>
                <span className="font-semibold">Customer Address </span> :{" "}
                {invoice.delivery_customer_address
                  ? invoice.delivery_customer_address
                  : invoice.customer_address}
              </p>
              <p>
                <span className="font-semibold">Customer ID </span> :{" "}
                {invoice.customer_id}
              </p>
              <p className="font-semibold">
                {invoice.user_id == 163 ||
                invoice.user_id == 190 ||
                invoice.user_id == 191
                  ? invoice?.purchases_vendor_names?.map((item, index) => {
                      return index === 0 ? item : item + ", ";
                    })
                  : ""}
              </p>
              {console.log(
                "Courier ................... ",
                invoice?.stead_fast_courier
              )}
              {invoice?.stead_fast_courier ? (
                <>
                  <p>
                    <span className="font-semibold"> Consignment ID </span> :{" "}
                    {invoice?.stead_fast_courier?.consignment_id}
                  </p>
                  <p>
                    <span className="font-semibold"> Tracking Code </span> :{" "}
                    {invoice?.stead_fast_courier?.tracking_code}
                  </p>
                </>
              ) : null}
              {invoice.remarks && invoice.remarks.trim() !== "" && (
                <p>
                  <span className="font-semibold">Remarks</span>: {invoice.remarks}
                </p>
              )}
            </div>
            {/* <div className="w-[45px] sm:w-[65px] md:w-[100px]"> */}
            <div className="flex flex-col justify-start items-start text-black space-y-[2px] md:space-y-[4px] font-nunito text-xs lg:text-base">
              {/* <QRCode className="w-full object-contain" value={BASE_URL + '/invoice/' + invoice.invoice_id} size={100} /> */}
                    {
                      user.id === 254 && invoice.custom_invoice_id !== null?
                      <p>
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.custom_invoice_id}{" "}
                      </p>
                      : <p>
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.invoice_id}{" "}
                      </p>
                    }
              <p>
                <span className="font-semibold">Invoice Date</span> :{" "}
                {formattedDateTime}
              </p>
            </div>
          </div>
          {/* <div className='text-xs  lg:text-base' style={{ width: '100%', backgroundColor: '#3056FA', padding: '10px', textAlign: 'center', margin: '15px auto' }}>
          <p className="text-white font-nunito py-1 text-14 font-bold uppercase">Invoice No: {invoice.invoice_id}</p>
        </div> */}
          {/* table */}
          <div className=" mx-auto md:w-full md:max-w-full overflow-x-auto mt-4 mb-0 px-0 sm:px-0">
            <table
              className={`table border-b-4 `}
              style={{
                borderColor: invoiceSetting?.dummy_text
                  ? invoiceSetting?.dummy_text
                  : "#93C5FD",
              }}
            >
              <thead id="pdfContentTHead">
                <tr
                  className={`leading-normal text-xs  lg:text-base font-nunito tracking-wide border-b-4 border-t-4 px-0 `}
                  style={{
                    borderColor: invoiceSetting?.dummy_text
                      ? invoiceSetting?.dummy_text
                      : "#93C5FD",
                  }}
                >
                  <th
                    className="font-nunito text-left"
                    style={{ padding: "3px 5px" }}
                  >
                    SL
                  </th>
                  <th
                    className="font-nunito text-start "
                    style={{ padding: "3px 5px" }}
                  >
                    Item Name
                  </th>
                  <th
                    className="font-nunito text-center"
                    style={{ padding: "3px 5px" }}
                  >
                    Warranty
                  </th>
                  <th
                    className="font-nunito text-center"
                    style={{ padding: "3px 5px" }}
                  >
                    Status
                  </th>
                  <th
                    className="font-nunito text-center"
                    style={{ padding: "3px 5px" }}
                  >
                    Quantity
                  </th>
                  <th
                    className="font-nunito text-right"
                    style={{ padding: "3px 5px" }}
                  >
                    Price
                  </th>
                  <th
                    className="font-nunito text-center sm:text-right "
                    style={{ padding: "3px 5px" }}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              {/* <tbody>

                {(() => {
                  let rowCounter = 0; // Define rowCounter outside the map function

                  return invoice?.sales_details?.map((item) => {
                    const productId = item.product_id;


                    const imeisDetails = imeisByProduct.filter(
                      (imeiDetail) => imeiDetail.product_id === productId
                    );
                    let subtotalPrice = 0;


                    subtotalPrice = formatPrice(
                      (item?.remaining_qty !== null &&
                      item?.remaining_qty !== undefined
                        ? item?.remaining_qty
                        : item?.qty) * item.price
                    ); // Calculate subtotal price for the product
                    totalQty += Number(
                      item?.remaining_qty !== null &&
                        item?.remaining_qty !== undefined
                        ? item?.remaining_qty
                        : item?.qty
                    ); // Add the quantity of the product
                    totalItems +=
                      item?.remaining_qty !== null &&
                      item?.remaining_qty !== undefined
                        ? item?.remaining_qty
                        : item?.qty; // Count this product as a single item
                    totalPrice += Number(subtotalPrice); // Add to the total price



                    return (
                      <tr
                        key={item.id}
                        className={`font-nunito  font-normal text-sm lg:text-base relative`}
                        style={{
                          borderColor: invoiceSetting?.dummy_text
                            ? invoiceSetting?.dummy_text
                            : "#93C5FD",
                        }}
                      >
                        <td className="text-left " style={{ padding: "10px" }}>
                          {++rowCounter}
                        </td>{" "}

                        <td className="" style={{ padding: "10px" }}>
                          {item?.product_info?.name} <br />
                          <span className="text-[13px]">
                            {item?.product_imei[0]?.imei
                              ? item?.product_imei[0]?.imei
                              : item?.product_info?.serial}
                          </span>
                        </td>
                        <td className="text-right " style={{ padding: "10px" }}>

                          {invoice.defaultwarranties &&
                            invoice.defaultwarranties.map(
                              (warrantyItem) =>
                                warrantyItem.invoice_id ===
                                  invoice.invoice_id &&
                                warrantyItem.product_id === item.product_id &&
                                (warrantyItem.warranty_id == null ? (
                                  <h1 className="text-sm">
                                    {warrantyItem?.default_warranties_count ||
                                      ""}{" "}
                                    {item?.product_info?.warrenty || ""}
                                  </h1>
                                ) : (
                                  <h1 className="text-sm">
                                    {warrantyItem?.warranty?.warranties_count ||
                                      ""}{" "}
                                    {warrantyItem?.warranty?.name || ""}
                                  </h1>
                                ))
                            )}
                        </td>
                        {console.log("called ", item?.remaining_qty)}
                        <td
                          className="text-center text-sm"
                          style={{ padding: "10px" }}
                        >
                          {item?.remaining_qty === 0 ||
                          item?.remaining_qty < item?.qty
                            ? "     " +
                              "Returned " +
                              (item?.qty - item?.remaining_qty)
                            : "Sold"}
                        </td>
                        <td
                          className="text-center text-sm"
                          style={{ padding: "10px" }}
                        >
                          {item?.remaining_qty !== null &&
                          item?.remaining_qty !== undefined
                            ? item?.remaining_qty
                            : item?.qty}
                        </td>
                        <td
                          className="text-right text-sm"
                          style={{ padding: "10px" }}
                        >
                          {item.price}
                        </td>
                        <td
                          className="text-right font-semibold md:font-semibold text-sm"
                          style={{ padding: "10px" }}
                        >
                          {subtotalPrice}
                          {invoiceSetting?.currency_info?.code || " BDT"}
                        </td>
                      </tr>
                    );
                  });
                })()}
                <tr>
                  <td>3</td>
                  <td>Name</td>
                  <td>Demo3</td>
                  <td>Demo4</td>
                  <td>Demo5</td>
                  <td>Demo6</td>
                </tr>
              </tbody> */}

              <tbody>
                {invoice?.sales_details
                  ? (() => {
                      let rowCounter = 0; // Define rowCounter within the outer function scope

                      return invoice?.sales_details?.map((item) => {
                        const productId = item.product_id;

                        const imeisDetails = imeisByProduct.filter(
                          (imeiDetail) => imeiDetail.product_id === productId
                        );

                        let subtotalPrice = 0;

                        subtotalPrice = formatPrice(
                          (item?.remaining_qty !== null &&
                          item?.remaining_qty !== undefined
                            ? item?.remaining_qty
                            : item?.qty) * item.price
                        ); // Calculate subtotal price for the product

                        totalQty += Number(
                          item?.remaining_qty !== null &&
                            item?.remaining_qty !== undefined
                            ? item?.remaining_qty
                            : item?.qty
                        ); // Add the quantity of the product

                        totalItems +=
                          item?.remaining_qty !== null &&
                          item?.remaining_qty !== undefined
                            ? item?.remaining_qty
                            : item?.qty; // Count this product as a single item

                        totalPrice += Number(subtotalPrice); // Add to the total price

                        return (
                          <tr
                            key={item.id}
                            className="font-nunito font-normal text-sm lg:text-base relative"
                            style={{
                              borderColor: invoiceSetting?.dummy_text
                                ? invoiceSetting?.dummy_text
                                : "#93C5FD",
                            }}
                          >
                            <td
                              className="text-left"
                              style={{ padding: "10px" }}
                            >
                              {++rowCounter}
                            </td>{" "}
                            {/* SL # */}
                            <td className="" style={{ padding: "10px" }}>
                              {item?.product_info?.name + ""}{" "}
                              {/* {item?.product_imei
                                ? `${
                                    item.product_imei[0]?.product_name || ""
                                  } ` +
                                  `${
                                    item.product_imei[0]?.optional_name || ""
                                  } ` +
                                  `${item.product_imei[0]?.color || ""} ` +
                                  `${
                                    item.product_imei[0]?.storage
                                      ? item.product_imei[0].storage + "GB "
                                      : ""
                                  }` +
                                  `${
                                    item.product_imei[0]?.battery_life
                                      ? "BH-" +
                                        item.product_imei[0].battery_life +
                                        "% "
                                      : ""
                                  }` +
                                  `${item.product_imei[0]?.regeion || ""}`
                                : ""} */}
                              {item?.product_imei
                                ? `${
                                    item.product_imei[0]?.product_name || ""
                                  } ${
                                    item.product_imei[0]?.optional_name || ""
                                  } ${item.product_imei[0]?.color || ""} ${
                                    item.product_imei[0]?.storage
                                      ? item.product_imei[0].storage + "GB"
                                      : ""
                                  }`.trim() +
                                  `  - ${item.product_imei[0]?.region || ""} ${
                                    item.product_imei[0]?.battery_life
                                      ? `(BH-${item.product_imei[0].battery_life}%)`
                                      : ""
                                  } - ${item.product_imei[0]?.box_status || ""}`
                                : ""}{" "}
                              <br />
                              <span className="text-[14px] font-semibold">
                                {item?.product_imei?.length > 0
                                  ? `SL/IMEI : ${item?.product_imei[0]?.imei}`
                                  : item?.product_info?.serial}
                              </span>
                              <span className="text-[14px]">
                                {item?.product_variant?.name
                                  ? item?.product_variant?.name
                                  : ""}
                              </span>
                            </td>
                            <td
                              className="text-right"
                              style={{ padding: "10px" }}
                            >
                              {invoice.defaultwarranties &&
                                invoice.defaultwarranties.map(
                                  (warrantyItem) =>
                                    warrantyItem.invoice_id ===
                                      invoice.invoice_id &&
                                    warrantyItem.product_id ===
                                      item.product_id &&
                                    (warrantyItem.warranty_id == null ? (
                                      <h1 className="text-sm">
                                        {warrantyItem?.default_warranties_count ||
                                          ""}{" "}
                                        {item?.product_info?.warrenty || ""}
                                      </h1>
                                    ) : (
                                      <h1 className="text-sm">
                                        {warrantyItem?.warranty
                                          ?.warranties_count || ""}{" "}
                                        {warrantyItem?.warranty?.name || ""}
                                      </h1>
                                    ))
                                )}
                            </td>
                            <td
                              className="text-center text-sm"
                              style={{ padding: "10px" }}
                            >
                              {parseInt(user.type) == 4 && invoice.status == 0
                                ? "Pending"
                                : item?.remaining_qty === 0 ||
                                  item?.remaining_qty < item?.qty
                                ? "Returned " +
                                  (item?.qty - item?.remaining_qty)
                                : "Sold"}
                            </td>
                            <td
                              className="text-center text-sm"
                              style={{ padding: "10px" }}
                            >
                              {item?.remaining_qty !== null &&
                              item?.remaining_qty !== undefined
                                ? item?.remaining_qty
                                : item?.qty}
                            </td>
                            <td
                              className="text-right text-sm"
                              style={{ padding: "10px" }}
                            >
                              {Intl.NumberFormat("en-IN").format(item.price)}
                            </td>
                            <td
                              className="text-right font-semibold md:font-semibold text-sm"
                              style={{ padding: "10px" }}
                            >
                              {Intl.NumberFormat("en-IN").format(subtotalPrice)}
                              {` ${
                                invoiceSetting?.currency_info?.code || "BDT"
                              }`}
                            </td>
                          </tr>
                        );
                      });
                    })()
                  : ""}

                {/* Exchange IMEIs Rows */}
                {invoice?.sales_details
                  ? (() => {
                      let exchangeTotalPrice = 0;
                      let rowCounter = invoice?.sales_details?.length || 0; // Continue rowCounter from the last sales row

                      const exchangeRows = exChangeImeis?.map(
                        (exchangeItem) => {
                          exchangeTotalPrice += Number(
                            exchangeItem?.purchase_price || 0
                          );

                          return (
                            <tr
                              key={`exchange-${exchangeItem.id}`}
                              className="font-nunito font-normal text-sm lg:text-base relative text-red-500"
                              style={{
                                borderColor: invoiceSetting?.dummy_text
                                  ? invoiceSetting?.dummy_text
                                  : "#93C5FD",
                              }}
                            >
                              <td
                                className="text-left"
                                style={{ padding: "10px" }}
                              >
                                {++rowCounter}
                              </td>
                              <td className="" style={{ padding: "10px" }}>
                                {/* {exchangeItem?.product_name} <br /> */}
                                {`${exchangeItem?.product_name || ""} ${
                                  exchangeItem?.color ? exchangeItem.color : ""
                                } ${exchangeItem?.storage ? `${exchangeItem.storage}GB` : ""} - ${exchangeItem?.regeion || exchangeItem?.region || ""} ${
                                  exchangeItem?.battery_life
                                    ? `(BH-${exchangeItem.battery_life}%)`
                                    : ""
                                }`}
                                <br />
                                <span className="text-[13px]">
                                  {exchangeItem?.imei || "N/A"}
                                </span>
                                <span className="text-[13px]">
                                  {" (Exchanged Product)"}
                                </span>
                              </td>
                              <td
                                className="text-right"
                                style={{ padding: "10px" }}
                              >
                                {exchangeItem?.optional_name || ""}
                              </td>
                              <td
                                className="text-center text-sm"
                                style={{ padding: "10px" }}
                              >
                                {""}
                              </td>
                              <td
                                className="text-center text-sm"
                                style={{ padding: "10px" }}
                              >
                                {""}
                              </td>
                              <td
                                className="text-right text-sm"
                                style={{ padding: "10px" }}
                              >
                                {Intl.NumberFormat("en-IN").format(
                                  exchangeItem?.purchase_price
                                ) || 0}
                              </td>
                              <td
                                className="text-right font-semibold md:font-semibold text-sm"
                                style={{ padding: "10px" }}
                              >
                                {Intl.NumberFormat("en-IN").format(
                                  exchangeItem?.purchase_price
                                ) || 0}
                                {` ${
                                  invoiceSetting?.currency_info?.code || "BDT"
                                }`}
                              </td>
                            </tr>
                          );
                        }
                      );

                      totalPrice -= exchangeTotalPrice; // Subtract exchangeTotalPrice from totalPrice

                      return exchangeRows;
                    })()
                  : ""}
              </tbody>
            </table>
          </div>
          {/* <DashedLine2 /> */}
          {/* <br /> */}
          {/* disclaimer & summary */}
          <div className="w-full flex flex-col md:flex-row justify-between pt-0 ml-auto gap-4 md:gap-0">
            {/* payment method */}
            {
              <div style={styles.paymentMethodDiv} className="w-full md:w-auto">
                {/* <div>
              {invoice?.multiple_payment?.length > 0 ? (
                <span>
                  Paid by {invoice?.multiple_payment?.map(payment => payment.payment_type.type_name).join(', ').replace(/, ([^,]*)$/, ' and $1')}
                </span>
              ) : (
                <span>No payment information available</span>
              )}
            </div> */}

                <div>
                  {invoice?.multiple_payment?.length > 0 ? (
                    <>
                      {(() => {
                        const grandTotal = parseFloat(
                          (
                            Number(totalPrice) +
                            Number(invoice?.vat || 0) +
                            Number(invoice?.tax || 0) +
                            Number(invoice?.delivery_fee || 0)
                          ).toFixed(2)
                        );
                        const discount = Number(invoice?.discount || 0);
                        const paidAmount = Number(
                          invoice.paid_amount && invoice.paid_amount !== 0
                            ? invoice.paid_amount
                            : 0
                        );
                        const dueAmount = grandTotal - paidAmount;

                        // Debugging values
                        console.log("grandTotal:", grandTotal);
                        console.log("discount:", discount);
                        console.log("paidAmount:", paidAmount);
                        console.log("dueAmount:", dueAmount);

                        const remainingAmount = dueAmount - paidAmount;
                        console.log("remainingAmount:", remainingAmount);

                        const isFullyPaid = dueAmount === 0;
                        const isFullyDue = paidAmount === 0;
                        const isPartiallyPaid = paidAmount > 0;
                        console.log("isFullyPaid:", isFullyPaid);
                        console.log("isFullyDue:", isFullyDue);
                        console.log("isPartiallyPaid:", isPartiallyPaid);

                        return (
                          <>
                            {isFullyDue ? (
                              <span>The amount is fully due</span>
                            ) : (
                              <>
                                {isFullyPaid ? (
                                  <span>
                                    Paid by{" "}
                                    {invoice?.multiple_payment
                                      ?.map(
                                        (payment) =>
                                          payment.payment_type?.type_name
                                      )
                                      .join(", ")
                                      .replace(/, ([^,]*)$/, " and $1")}{" "}
                                  </span>
                                ) : (
                                  <span>
                                    Paid by{" "}
                                    {invoice?.multiple_payment
                                      ?.map(
                                        (payment) =>
                                          payment.payment_type?.type_name
                                      )
                                      .join(", ")
                                      .replace(/, ([^,]*)$/, " and $1")}{" "}
                                    {isPartiallyPaid ? "Partially" : ""}
                                  </span>
                                )}
                              </>
                            )}
                          </>
                        );
                      })()}
                    </>
                  ) : (
                    <span>No payment information available</span>
                  )}
                </div>
              </div>
            }

            {/* invoice sumary */}
            <div className="w-full sm:w-1/3 text-sm font-semibold pl-4 md:pl-12 pr-6 sm:pr-0">
              <div className="space-y-[2px] mb-2">
                <p className="flex justify-between">
                  <span className="pl-5">Sub Total</span>
                  <span>
                    {Intl.NumberFormat("en-IN").format(formatPrice(totalPrice))}
                    {invoiceSetting?.currency_info?.code
                      ? ` ${invoiceSetting.currency_info.code}`
                      : " BDT"}
                  </span>
                </p>
                {invoice?.delivery_info_id && (
                  <p className="flex justify-between">
                    <span className="pl-5">Delivery Fee</span>
                    <span>
                      {Intl.NumberFormat("en-IN").format(
                        formatPrice(
                          invoice.delivery_fee ? invoice.delivery_fee : 0
                        )
                      )}
                      {invoiceSetting?.currency_info?.code
                        ? ` ${invoiceSetting.currency_info.code}`
                        : " BDT"}
                    </span>
                  </p>
                )}
                <p className="flex justify-between">
                  <span className="pl-5">Discount</span>
                  <span>
                    {Intl.NumberFormat("en-IN").format(
                      formatPrice(invoice.discount ? invoice.discount : 0)
                    )}
                    {invoiceSetting?.currency_info?.code
                      ? ` ${invoiceSetting.currency_info.code}`
                      : " BDT"}
                  </span>
                </p>
              </div>
              <hr></hr>
              <div className="my-2">
                <p className="flex justify-between">
                  <span className="pl-5">Grand Total</span>
                  <span>
                    {Intl.NumberFormat("en-IN").format(
                      (
                        Number(totalPrice) +
                        Number(invoice?.vat) +
                        Number(invoice?.tax) +
                        Number(invoice?.delivery_fee) -
                        Number(invoice?.discount)
                      ).toFixed(2)
                    )}
                    {invoiceSetting?.currency_info?.code
                      ? ` ${invoiceSetting.currency_info.code}`
                      : " BDT"}
                  </span>
                </p>

              {invoice?.multiple_payment?.length > 0 &&
                invoice.multiple_payment.map((payment, index) => (
                  <p key={index} className="flex justify-between">
                    <span className="pl-5">
                      {payment.payment_type?.type_name ||
                        payment.payment_type_category?.[0]?.payment_category_name ||
                        "Unknown"}{" "}
                      Payment{" "}
                      {payment.invoice_id?.includes("INV-DUE") && (
                        <span className="text-[10px] text-gray-500">(Due Payment)</span>
                      )}
                    </span>

                    <span>
                      {Intl.NumberFormat("en-IN").format(payment.payment_amount)}{" "}
                      {invoiceSetting?.currency_info?.code || "BDT"}
                    </span>
                  </p>
                ))}
                <p className="flex justify-between">
                  <span className="pl-5">Paid Amount</span>
                  <span>
                    {(() => {
                      const totalExchangePrice =
                        exChangeImeis?.reduce(
                          (acc, item) => acc + (item.purchase_price || 0),
                          0
                        ) || 0;

                      const adjustedPaidAmount =
                        invoice.paid_amount && invoice.paid_amount !== ""
                          ? invoice.paid_amount
                          : 0;

                      return (
                        Intl.NumberFormat("en-IN").format(
                          formatPrice(adjustedPaidAmount)
                        ) + ` ${invoiceSetting?.currency_info?.code || "BDT"}`
                      );
                    })()}
                  </span>
                </p>
                {parseInt(user.type) == 4 && (
                  <>
                    <p className="flex justify-between">
                      <span className="pl-5">Change</span>
                      <span className="">
                        {invoice?.cash_change && invoice?.cash_change != ""
                          ? formatPrice(parseFloat(invoice?.cash_change))
                          : formatPrice(0)}
                        {invoiceSetting?.currency_info?.code
                          ? ` ${invoiceSetting.currency_info.code}`
                          : " BDT"}
                      </span>
                    </p>
                  </>
                )}
              </div>
              <hr></hr>
              <p className="flex justify-between mt-2">
                <span className="pl-5">Due Amount</span>
                <span>
                  {Number.parseFloat(
                    Number(totalPrice) +
                      Number(invoice?.vat) +
                      Number(invoice?.tax) +
                      Number(invoice?.delivery_fee) -
                      Number(invoice?.discount) -
                      Number(
                        invoice.paid_amount && invoice.paid_amount != ""
                          ? formatPrice(invoice.paid_amount)
                          : formatPrice(0)
                      ) - totalDuePayment
                  ).toFixed(2) < 0
                    ? 0
                    : Intl.NumberFormat("en-IN").format(
                        Number.parseFloat(
                          Number(totalPrice) +
                            Number(invoice?.vat) +
                            Number(invoice?.tax) +
                            Number(invoice?.delivery_fee) -
                            Number(invoice?.discount) -
                            Number(
                              invoice.paid_amount && invoice.paid_amount != ""
                                ? formatPrice(invoice.paid_amount)
                                : formatPrice(0)
                            ) - totalDuePayment
                        ).toFixed(2)
                      )}
                  {invoiceSetting?.currency_info?.code
                    ? ` ${invoiceSetting.currency_info.code}`
                    : " BDT"}
                </span>
              </p>
            </div>
          </div>
          <div
            style={
              invoiceSetting?.dummy_text
                ? {
                    backgroundColor: invoiceSetting?.dummy_text,
                    color: "white",
                    WebkitPrintColorAdjust: "exact",
                    padding: "10px 10px 10px 10px",
                    textAlign: "center",
                    margin: "13px 0px 10px 0px",
                  }
                : { ...styles.div }
            }
          >
            <p className="text-white font-nunito text-sm font-bold">
              You saved {formatPrice(invoice.discount ? invoice.discount : 0)}
              {/* You saved {invoice.discount ? invoice.discount : 0} */}
              {invoiceSetting?.currency_info?.code
                ? invoiceSetting?.currency_info?.code
                : " BDT"}{" "}
              in this purchase{" "}
            </p>
          </div>
          {/* web address qr code */}
          <QRCode
            className="w-[70px] object-contain p-0 mx-auto sm:mx-0"
            value={
              invoice?.user_info?.web_address ||
              invoice?.user_info?.invoice_settings?.web_address ||
              "No Web Address set to the QR code"
            }
            size={70}
          />
          {/* signature */}
          {/* <div className='text-xs md:text-sm lg:text-base border\'>
            <div className='flex justify-end'>
              <p className="invisible">.</p>
              {!id && invoiceSetting?.sign_authority ? <div className='w-[120px] h-[120px] rounded-lg'>
                <img src={invoiceSetting.sign_authority} className='object-cover excludeFromPdf' />
              </div> : null}
            </div>
            <div className="flex justify-end m-2">
              <p><hr></hr> Authorized Signature </p>
            </div>
        </div> */}
          {/* terms and conditions */}
          {/* <div class=" border">
          <h3 class="text-sm font-semibold text-gray-800 mb-2">Terms and Conditions</h3>
          <ul class="list-disc list-inside text-gray-700 text-xs">
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
              <li>Nulla facilisi. Suspendisse potenti.</li>
              <li>Mauris ut metus non nisl pulvinar cursus.</li>
          </ul>
        </div> */}
          {/* Terms and Conditions Section */} {/* Signature Section */}
          <div className="flex flex-col md:flex-row space-x-0 md:space-x-4 text-xs md:text-sm lg:text-base">
  {/* Terms and Conditions */}
  <div className="pt-2 w-full md:w-1/2 pl-12 sm:pl-0">
    <h3 className="text-lg font-semibold text-gray-800 mb-2">
      Terms and Conditions
    </h3>
    <ul className="list-disc list-inside text-gray-700 text-2xl">
      {/* <li>All prices include taxes. Payment must be made in full at the time of purchase via accepted payment methods.</li>
          <li>Disputes will be resolved under the laws of Bangladesh.</li>
          <li>Defective or incorrect items will be replaced or refunded at no additional cost.</li> */}
      {inputs.map((item, index) => (
        <li className="text-base" key={item.id || index}>{item.description}</li>
      ))}
    </ul>
  </div>

  {/* Signature Section */}
  <div className="p-4 flex flex-col items-center md:items-end w-full md:w-1/2 mt-4 md:mt-0">
    <div className="flex justify-center md:justify-end">
      <p className="invisible">.</p>
      {!id && invoiceSetting?.sign_authority ? (
        <div className="w-[120px] h-[120px] rounded-lg">
          <img
            src={invoiceSetting?.sign_authority}
            className="object-cover excludeFromPdf"
          />
        </div>
      ) : null}
    </div>
    <div className="flex justify-center md:justify-end mt-2">
      <p>
        <hr /> Authorized Signature{" "}
      </p>
    </div>
  </div>
</div>
          {/* footer */}
          <div className="text-center font-nunito mt-0 text-xs md:text-sm lg:text-base">
            <h2 className="text-orange-500  text-xl font-semibold ">
              Thanks for purchase
            </h2>
            {/* <p className="text-black mt-3 text-xs mb-2">
              A Product of {invoice?.user_info?.invoice_settings?.shop_name}{" "}
            </p> */}
          </div>
        </div>
      </div>

      {/* this is the pownload file */}
      <div className="hidden">
        <div id="pdfConentAreas" className="pdfConentAreas relative">
          {/* watermark text */}
          <div
            className="absolute top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none"
            style={{
              zIndex: 0,
              color: "rgba(0, 0, 0, 0.1)", // Light gray watermark text
              fontSize: "5rem",
              fontWeight: "normal",
              transform: "rotate(-45deg)",
              userSelect: "none",
            }}
          >
            {invoiceSetting?.watermark_text || ""}
          </div>
          <div className="relative z-10">
            <div
              id="invoice-detail-page"
              className="invoice-detail-page font-nunito"
            >
              {/* invoice header */}
              <div
                className={`flex justify-between items-center pt-4 border-b-4`}
                style={{
                  borderColor: invoiceSetting?.dummy_text
                    ? invoiceSetting?.dummy_text
                    : "#93C5FD",
                }}
              >
                {/* Shop Logo Section */}
                <div className="w-1/3 flex flex-col justify-start items-start">
                  <img
                    src={invoiceSetting?.shop_logo}
                    alt="Shop Logo"
                    className="w-[40px] sm:w-[60px] md:w-[80px] object-contain"
                  />
                  <p className="mt-2">
                    {" "}
                    {/* Adds some spacing between image and text */}
                    <span
                      className="font-semibold text-sm"
                      style={{ letterSpacing: "0.08em" }}
                    >
                      Sale Invoice
                    </span>
                  </p>
                </div>

                {/* QR Code Section */}
                <div className="w-1/3 flex justify-center">
                  <div className="w-[45px] sm:w-[65px] md:w-[100px]">
                    <QRCode
                      className="w-full object-contain"
                      value={BASE_URL + "/invoice-view/" + invoice?.invoice_id}
                      size={100}
                    />
                  </div>
                </div>

                {/* Shop Info Section */}
                <div className="w-1/3 flex flex-col justify-end items-start">
                  <span
                    className="font-semibold text-md sm:text-xl md:text-2xl"
                    style={{ letterSpacing: "0.08em" }}
                  >
                    {invoiceSetting?.shop_name}
                  </span>
                  <span className="text-xs text-gray-600">
                    <strong>Phone:</strong> {invoiceSetting?.mobile_number}
                  </span>
                  <span className="text-xs text-gray-600">
                    <strong>Email:</strong> {invoice?.user_info?.email}
                  </span>
                  <span className="text-xs text-gray-600">
                    <strong>Address:</strong> {userInfo?.address}
                  </span>
                </div>
              </div>
              {/* customer info and  + QR*/}
              <div className="flex items-center mt-[10px] justify-between">
                <div className="text-black space-y-[2px] md:space-y-[6px] font-nunito text-xs  lg:text-base">
                  {/* <p> <span className='font-semibold'>Customer Name</span>  :  {invoice.customer_name} </p>
              <p><span className='font-semibold'>Customer Phone</span> :  {invoice.country_code}{invoice.customer_phone}</p>
              <p><span className='font-semibold'> Customer ID </span> :#{invoice.customer_id}</p>
              <p><span className='font-semibold'> Invoice Date </span>: {formattedDateTime} </p> */}
                  <p>
                    {" "}
                    <span className="font-semibold">Bill to,</span> <br />{" "}
                    <span className="font-semibold">Customer Name </span> :{" "}
                    {invoice?.delivery_customer_name
                      ? invoice?.delivery_customer_name
                      : invoice?.customer_name}{" "}
                  </p>
                  <p>
                    <span className="font-semibold">Customer Phone</span> :{" "}
                    {invoice.country_code}
                    {invoice?.delivery_customer_phone
                      ? invoice?.delivery_customer_phone
                      : invoice?.customer_phone}
                  </p>
                  <p>
                    <span className="font-semibold">Customer Address </span> :{" "}
                    {invoice.delivery_customer_address
                      ? invoice.delivery_customer_address
                      : invoice.customer_address}
                  </p>
                  <p>
                    <span className="font-semibold"> Customer ID </span> :{" "}
                    {invoice.customer_id}
                  </p>
                  <p className="font-semibold">
                    {invoice.user_id == 163 ||
                    invoice.user_id == 190 ||
                    invoice.user_id == 191
                      ? invoice?.purchases_vendor_names?.map((item, index) => {
                          return index === 0 ? item : item + ", ";
                        })
                      : ""}
                  </p>
                  {console.log(
                    "Courier ................... ",
                    invoice?.stead_fast_courier
                  )}
                  {invoice?.stead_fast_courier ? (
                    <>
                      <p>
                        <span className="font-semibold"> Consignment ID </span>{" "}
                        : {invoice?.stead_fast_courier?.consignment_id}
                      </p>
                      <p>
                        <span className="font-semibold"> Tracking Code </span> :{" "}
                        {invoice?.stead_fast_courier?.tracking_code}
                      </p>
                    </>
                  ) : null}
                  {invoice.remarks && invoice.remarks.trim() !== "" && (
                    <p>
                      <span className="font-semibold">Remarks</span>: {invoice.remarks}
                    </p>
                  )}
                </div>
                {/* <div className="w-[45px] sm:w-[65px] md:w-[100px]"> */}
                <div className="flex flex-col justify-start items-start text-black space-y-[2px] md:space-y-[4px] font-nunito text-xs  lg:text-base">
                  {/* <QRCode className="w-full object-contain" value={BASE_URL + '/invoice/' + invoice.invoice_id} size={100} /> */}
                  {console.log("delivery method....... ",invoice.delivery_method)}
                    {invoice.delivery_method?.type_name.toLowerCase() !== 'hand-to-hand' ? (
                      <>
                        <p>
                          {
                            invoice.delivery_method?.delivery_infos?.length > 0 && <>
                                <span className="font-bold">Delivery Company</span>:{" "}
                                <span>
                                {invoice.delivery_method?.delivery_infos[0]?.company_name}{" "}
                                </span>
                              </>
                          }
                        </p>
                        <p>
                          <span className="font-bold">Receiver Name </span>:{" "}
                          <span>{invoice.delivery_customer_name}</span>
                        </p>
                        <p>
                          <span className="font-bold">Receiver Phone </span>:{" "}
                          <span className="">{invoice.delivery_customer_phone}</span>
                        </p>
                        <p>
                          <span className="font-bold">Receiver Address</span> :{" "}
                          <span className="">
                            {invoice.delivery_customer_address}
                          </span>
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                    {
                      console.log("user......... ",user.id)
                    }
                    {
                      console.log("invoice.custom_invoice_id......... ",invoice.custom_invoice_id)
                    }
                    {
                      user.id === 254 && invoice.custom_invoice_id !== null?
                      <p>
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.custom_invoice_id}{" "}
                      </p>
                      : <p>
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.invoice_id}{" "}
                      </p>
                    }

                  <p>
                    <span className="font-semibold">Invoice Date</span> :{" "}
                    {formattedDateTime}
                  </p>
                </div>
              </div>
              {/* invoice serial */}
              {/* <div
            className="text-xs  lg:text-base"
            style={{
              width: "100%",
              backgroundColor: "#3056FA",
              padding: "0 10px 10px 0px",
              textAlign: "center",
              margin: "5px auto",
            }}
          >
            <p className="text-white font-nunito py-1 text-14 font-bold uppercase">
              Invoice No: {invoice.invoice_id}
            </p>
          </div> */}
              {/* <div className="max-w-[calc(100vw-28vw)] w-[calc(100vw-28vw)] mx-auto md:w-full md:max-w-full overflow-x-auto"> */}
              {/* <div className="overflow-x-auto ">
            <table className="table">
              <thead id="pdfContentTHead">
                <tr className="leading-normal text-sm  lg:text-base font-nunito tracking-wide">
                  <th className="pb-3 font-nunito">Item Name</th>
                  <th className="pb-3 font-nunito text-center ">Warranty</th>
                  <th className="pb-3 font-nunito text-center">Quantity</th>
                  <th className="pb-3 font-nunito text-center">Price</th>
                  <th className="pb-3 font-nunito text-right">Total</th>
                </tr>
              </thead>
              <tbody textAlign="start">
                {invoice?.sales_details?.map((item) => {
                  const findImeis = invoiceImeis.filter( (imei) => imei?.product_id === item?.product_id )
                  let subtotalPrice = 0;
                  if(findImeis?.length){
                    const qty = Number.parseInt(findImeis?.length)
                    totalItemsPrint += qty;
                    const sumPrice = findImeis?.reduce( (acc, prod)=>{
                      return acc + prod.sale_price
                    },0)
                    subtotalPrice = sumPrice;
                    totalPricePrint += Number(subtotalPrice);
                  }
                  else{
                    totalQty += Number(item.qty);
                    totalItemsPrint += 1;
                    subtotalPrice = formatPrice(item.qty * item.price);
                    totalPricePrint += Number(subtotalPrice);
                  }
                  return (
                    findImeis?.length ?
                    (
                      findImeis?.map((imei)=>(
                        <tr
                        key={item.id}
                        className=" font-nunito border-[#E7EBF4] font-normal text-sm  lg:text-base relative"
                      >
                        <td className="pt-0">{imei?.product_name} {imei?.optional_name}<br /><span className='text-[13px]'>{imei?.imei}</span></td>
                        <td className="pt-0 text-center">
                          {
                            invoice.defaultwarranties &&
                            invoice.defaultwarranties.map((warrantyItem) => (
                              warrantyItem.invoice_id === invoice.invoice_id && warrantyItem.product_id===item.product_id &&
                              (
                                warrantyItem.warranty_id==null ? (
                                  <h1 className='text-sm'>{warrantyItem?.default_warranties_count==null?"":warrantyItem?.default_warranties_count} {" "}
                                  {item?.product_info?.warrenty==null?"":item?.product_info?.warrenty}
                                  </h1>
                                ) : (
                                  <h1 className='text-sm'>{warrantyItem?.warranty?.warranties_count==null?"":warrantyItem?.warranty?.warranties_count}
                                  {" "}{warrantyItem?.warranty?.name==null?"":warrantyItem?.warranty?.name}</h1>
                                )
                              )
                            ))
                          }
                        </td>
                        <td className="pt-0 text-center">{"1"}</td>
                        <td className="pt-0 text-center">{imei?.sale_price}</td>
                        <td className="pt-0 text-right font-semibold md:font-semibold">
                          {imei?.sale_price}
                          {invoiceSetting?.currency_info?.code
                            ? invoiceSetting?.currency_info
                                ?.code
                            : " BDT"}
                        </td>
                      </tr>) ))
                      :
                      (<tr
                        key={item.id}
                        className=" font-nunito border-[#E7EBF4] font-normal text-sm  lg:text-base relative"
                      >
                        <td className="pt-0">{item?.product_info?.name}<br /><span className='text-[13px]'>{item?.product_info?.serial}</span></td>
                        <td className="pt-0 text-center">
                          {
                            invoice.defaultwarranties &&
                            invoice.defaultwarranties.map((warrantyItem) => (
                              warrantyItem.invoice_id === invoice.invoice_id && warrantyItem.product_id===item.product_id &&
                              (
                                warrantyItem.warranty_id==null ? (
                                  <h1 className='text-sm'>{warrantyItem?.default_warranties_count==null?"":warrantyItem?.default_warranties_count} {" "}
                                  {item?.product_info?.warrenty==null?"":item?.product_info?.warrenty}
                                  </h1>
                                ) : (
                                  <h1 className='text-sm'>{warrantyItem?.warranty?.warranties_count==null?"":warrantyItem?.warranty?.warranties_count}
                                  {" "}{warrantyItem?.warranty?.name==null?"":warrantyItem?.warranty?.name}</h1>
                                )
                              )
                            ))
                          }
                        </td>
                        <td className="pt-0 text-center">{item.qty}</td>
                        <td className="pt-0 text-center">{item.price}</td>
                        <td className="pt-0 text-right font-semibold md:font-semibold">
                          {subtotalPrice}
                          {invoiceSetting?.currency_info?.code
                            ? invoiceSetting?.currency_info
                                ?.code
                            : " BDT"}
                        </td>
                      </tr>)
                  );
                })}
              </tbody>
            </table>
          </div> */}
              <div className="mx-auto md:w-full md:max-w-full overflow-x-auto mb-0 mt-3">
                <table className="table ">
                  <thead id="pdfContentTHead" className="pb-3">
                    <tr
                      className={`leading-normal text-sm lg:text-base font-nunito tracking-wide border-b-4 border-t-4`}
                      style={{
                        borderColor: invoiceSetting?.dummy_text
                          ? invoiceSetting?.dummy_text
                          : "#93C5FD",
                      }}
                    >
                      <th
                        className="font-nunito text-left"
                        style={{ padding: "3px 5px" }}
                      >
                        #
                      </th>
                      <th
                        className="font-nunito text-start"
                        style={{ padding: "3px 5px" }}
                      >
                        Item Name
                      </th>
                      <th
                        className="font-nunito text-center"
                        style={{ padding: "3px 5px" }}
                      >
                        Warranty
                      </th>
                      <th
                        className="font-nunito text-center"
                        style={{ padding: "3px 5px" }}
                      >
                        Quantity
                      </th>
                      <th
                        className="font-nunito text-right"
                        style={{ padding: "3px 5px" }}
                      >
                        Price
                      </th>
                      <th
                        className="font-nunito text-right"
                        style={{ padding: "3px 5px" }}
                      >
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className="mt-2">
                    {(() => {
                      let rowCounter = 0; // Define rowCounter at the top level
                      const processedProductIds = new Set(); // To track processed product IDs and avoid duplicates
                      let subtotalPrice = 0; // To track the total price of all sales products before exchanges
                      console.log("invocie")
                      console.log(invoice)
                      console.log("invocie Imeis")
                      console.log(invoiceImeis)
                      // Sales Rows
                      const salesRows = invoice?.sales_details?.map((item) => {
                        const findImeis = invoiceImeis.filter(
                          (imei) => imei.product_id === item.product_id
                        );

                        if (findImeis.length > 0) {
                          // Skip duplicate product IDs
                          if (processedProductIds.has(item.product_id))
                            return null;
                          processedProductIds.add(item.product_id);
                        }
                        if (findImeis.length > 0) {
                          // Calculate total price for items with IMEIs
                          const qty = findImeis.length;
                          totalItemsPrint += qty;
                          subtotalPrice += findImeis.reduce(
                            (acc, prod) => acc + prod.sale_price,
                            0
                          );
                        } else {
                          // For items without IMEIs
                          const itemSubtotal = item.qty * item.price;
                          subtotalPrice += itemSubtotal;
                          totalItemsPrint += 1;
                          totalQty += Number(item.qty);
                        }

                        // Render rows for products
                        return findImeis.length > 0 ? (
                          findImeis.map((imei) => (
                            <tr
                              key={imei.id}
                              className="font-nunito border-[#E7EBF4] font-normal text-sm lg:text-base relative "
                            >
                              <td
                                className="text-left"
                                style={{ padding: "10px" }}
                              >
                                {++rowCounter}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {/* {imei?.product_name} {imei?.optional_name} {imei?.color}{" "}
                                {imei?.storage ? `${imei.storage}GB` : ""}{" "}
                                {imei?.battery_life ? `BH-${imei.battery_life}%` : ""}{" "}
                                {imei?.regeion}
                                <br />
                                <span className="text-[10px]">{imei?.imei}</span> */}
                                {`${imei?.product_name || ""} ${
                                  imei?.optional_name || ""
                                } ${imei?.color || ""} ${
                                  imei?.storage ? imei.storage + "GB" : ""
                                } - ${imei?.region || ""} ${
                                  imei?.battery_life
                                    ? `(BH-${imei.battery_life}%)`
                                    : ""
                                } ${
                                  imei?.box_status
                                    ? `( ${imei?.box_status}%)`
                                    : ""
                                }`}
                                <br />
                                <span className="text-[14px] font-semibold">
                                  {item?.product_imei?.length > 0
                                    ? `SL/IMEI : ${item?.product_imei[0]?.imei}`
                                    : item?.product_info?.serial}
                                </span>
                                <span className="text-[13px]">
                                  {imei?.product_variant?.name
                                    ? imei?.product_variant?.name
                                    : ""}
                                </span>
                              </td>
                              <td
                                className="text-center"
                                style={{ padding: "10px" }}
                              >
                                {invoice.defaultwarranties &&
                                  invoice.defaultwarranties.map(
                                    (warrantyItem) =>
                                      warrantyItem.invoice_id ===
                                        invoice.invoice_id &&
                                      warrantyItem.product_id ===
                                        item.product_id
                                        ? warrantyItem.warranty_id == null
                                          ? `${
                                              warrantyItem.default_warranties_count ||
                                              ""
                                            } ${
                                              item.product_info.warrenty || ""
                                            }`
                                          : `${
                                              warrantyItem.warranty
                                                ?.warranties_count || ""
                                            } ${
                                              warrantyItem.warranty?.name || ""
                                            }`
                                        : null
                                  )}
                              </td>
                              <td
                                className="text-center"
                                style={{ padding: "10px" }}
                              >
                                1
                              </td>
                              <td
                                className="text-right"
                                style={{ padding: "10px" }}
                              >
                                {Intl.NumberFormat("en-IN").format(
                                  imei.sale_price
                                )}
                              </td>
                              <td
                                className="text-right font-semibold"
                                style={{ padding: "10px" }}
                              >
                                {Intl.NumberFormat("en-IN").format(
                                  imei.sale_price
                                )}{" "}
                                {invoiceSetting?.currency_info?.code || "BDT"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr
                            key={item.id}
                            className="font-nunito border-[#E7EBF4] font-normal text-sm lg:text-base relative "
                          >
                            {console.log("item inside.... ", item)}
                            <td
                              className="text-left"
                              style={{ padding: "10px" }}
                            >
                              {++rowCounter}
                            </td>
                            <td style={{ padding: "10px" }}>
                              {item.product_info.name}
                              <br />
                              <span className="text-[10px]">
                                {item.product_info.serial}
                              </span>
                              <span className="text-[13px]">
                                {item?.product_variant?.name
                                  ? item?.product_variant?.name
                                  : ""}
                              </span>
                            </td>
                            <td
                              className="text-center"
                              style={{ padding: "10px" }}
                            >
                              {invoice.defaultwarranties &&
                                invoice.defaultwarranties.map((warrantyItem) =>
                                  warrantyItem.invoice_id ===
                                    invoice.invoice_id &&
                                  warrantyItem.product_id === item.product_id
                                    ? warrantyItem.warranty_id == null
                                      ? `${
                                          warrantyItem.default_warranties_count ||
                                          ""
                                        } ${item.product_info.warrenty || ""}`
                                      : `${
                                          warrantyItem.warranty
                                            ?.warranties_count || ""
                                        } ${warrantyItem.warranty?.name || ""}`
                                    : null
                                )}
                            </td>
                            <td
                              className="text-center"
                              style={{ padding: "10px" }}
                            >
                              {item.qty}
                            </td>
                            <td
                              className="text-right"
                              style={{ padding: "10px" }}
                            >
                              {item.price}
                            </td>
                            <td
                              className="text-right font-semibold"
                              style={{ padding: "10px" }}
                            >
                              {item.qty * item.price}{" "}
                              {invoiceSetting?.currency_info?.code || "BDT"}
                            </td>
                          </tr>
                        );
                      });

                      // Exchange Rows
                      let exchangeTotalPrice = 0; // Total price of exchanged products
                      const exchangeRows = exChangeImeis?.map(
                        (exchangeItem) => {
                          exchangeTotalPrice += Number(
                            exchangeItem.purchase_price || 0
                          );

                          return (
                            <tr
                              key={`exchange-${exchangeItem.id}`}
                              className="font-nunito font-normal text-sm lg:text-base relative text-red-500"
                              // style={{
                              //   borderColor:
                              //     invoiceSetting?.dummy_text || "#93C5FD",
                              // }}
                            >
                              <td
                                className="text-left"
                                style={{ padding: "10px" }}
                              >
                                {++rowCounter}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {/* {exchangeItem.product_name} */}
                                {`${exchangeItem?.product_name || ""} ${
                                  exchangeItem?.color ? exchangeItem.color : ""
                                } ${exchangeItem?.storage ? `${exchangeItem.storage}GB` : ""} - ${exchangeItem?.regeion || ""} ${
                                  exchangeItem?.battery_life
                                    ? `(BH-${exchangeItem.battery_life}%)`
                                    : ""
                                }
                                ${
                                  exchangeItem?.box_status
                                    ? ` (${exchangeItem.box_status})`
                                    : ""
                                }`}

                                <br />
                                <span className="text-[13px]">
                                  {exchangeItem.imei || "N/A"}
                                </span>
                                <span className="text-[13px]">
                                  {" (Exchanged Product)"}
                                </span>
                              </td>
                              <td
                                className="text-right"
                                style={{ padding: "10px" }}
                              >
                                {exchangeItem.optional_name || ""}
                              </td>
                              <td
                                className="text-center"
                                style={{ padding: "10px" }}
                              >
                                {""}
                              </td>
                              <td
                                className="text-right"
                                style={{ padding: "10px" }}
                              >
                                {Intl.NumberFormat("en-IN").format(
                                  exchangeItem.purchase_price
                                ) || 0}
                              </td>
                              <td
                                className="text-right font-semibold"
                                style={{ padding: "10px" }}
                              >
                                {Intl.NumberFormat("en-IN").format(
                                  exchangeItem.purchase_price
                                ) || 0}{" "}
                                {invoiceSetting?.currency_info?.code || "BDT"}
                              </td>
                            </tr>
                          );
                        }
                      );

                      totalPricePrint = subtotalPrice - exchangeTotalPrice; // Subtract exchange prices from subtotal

                      return [...salesRows, ...exchangeRows];
                    })()}
                  </tbody>
                </table>
                <div
                  className={`border-b-4  mt-3 mb-3`}
                  style={{
                    borderColor: invoiceSetting?.dummy_text
                      ? invoiceSetting?.dummy_text
                      : "#93C5FD",
                  }}
                ></div>
              </div>
              <div className="w-full flex justify-between pt-0 ml-auto ">
                {/* disclaimer */}
                {/* payment method */}
                <div style={styles.paymentMethodPrintDiv}>
                  {/* <div>
                  {invoice?.multiple_payment?.length > 0 ? (
                    <span className="" style={{ letterSpacing: "0.08em" }}>
                      Paid by{" "}
                      {invoice.multiple_payment
                        .map((payment) => payment.payment_type.type_name)
                        .join(", ")
                        .replace(/, ([^,]*)$/, " and $1")}
                    </span>
                  ) : (
                    <span>No payment information available</span>
                  )}
                </div> */}

                  {/* Here added the code by Saif */}
                  <div>
                    {invoice?.multiple_payment?.length > 0 ? (
                      <>
                        {(() => {
                          const grandTotal = parseFloat(
                            (
                              Number(totalPrice) +
                              Number(invoice?.vat || 0) +
                              Number(invoice?.tax || 0) +
                              Number(invoice?.delivery_fee || 0)
                            ).toFixed(2)
                          );
                          const discount = Number(invoice?.discount || 0);
                          const paidAmount = Number(
                            invoice.paid_amount && invoice.paid_amount !== 0
                              ? invoice.paid_amount
                              : 0
                          );
                          const dueAmount = grandTotal - paidAmount;

                          // Debugging values
                          console.log("grandTotal:", grandTotal);
                          console.log("discount:", discount);
                          console.log("paidAmount:", paidAmount);
                          console.log("dueAmount:", dueAmount);

                          const remainingAmount = dueAmount - paidAmount;
                          console.log("remainingAmount:", remainingAmount);

                          const isFullyPaid = dueAmount === 0;
                          const isFullyDue = paidAmount === 0;
                          const isPartiallyPaid = paidAmount > 0;
                          console.log("isFullyPaid:", isFullyPaid);
                          console.log("isFullyDue:", isFullyDue);
                          console.log("isPartiallyPaid:", isPartiallyPaid);

                          return (
                            <>
                              {isFullyDue ? (
                                <span style={{ letterSpacing: "0.08em" }}>
                                  The amount is fully due
                                </span>
                              ) : (
                                <>
                                  {isFullyPaid ? (
                                    <span style={{ letterSpacing: "0.08em" }}>
                                      Paid by{" "}
                                      {invoice?.multiple_payment
                                        ?.map(
                                          (payment) =>
                                            payment.payment_type?.type_name
                                        )
                                        .join(", ")
                                        .replace(/, ([^,]*)$/, " and $1")}{" "}
                                    </span>
                                  ) : (
                                    <span style={{ letterSpacing: "0.08em" }}>
                                      Paid by{" "}
                                      {invoice?.multiple_payment
                                        ?.map(
                                          (payment) =>
                                            payment.payment_type?.type_name
                                        )
                                        .join(", ")
                                        .replace(/, ([^,]*)$/, " and $1")}{" "}
                                      {isPartiallyPaid ? "Partially" : ""}
                                    </span>
                                  )}
                                </>
                              )}
                            </>
                          );
                        })()}
                      </>
                    ) : (
                      <span>No payment information available</span>
                    )}
                  </div>
                </div>
                {/* invoice sumary */}
                <div className="w-1/3 text-xs font-semibold pl-12">
                  <div className="space-y-[2px] mb-2">
                    {/* <p className="flex justify-between">
                  <span>Total Items</span>
                  <span>{totalItemsPrint}</span>
                </p> */}
                    <p className="flex justify-between">
                      <span>Sub Total</span>
                      <span>
                        {Intl.NumberFormat("en-IN").format(
                          formatPrice(totalPricePrint)
                        )}
                        {/* {totalPrice} */}
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : " BDT"}
                      </span>
                    </p>
                    <p className="flex justify-between">
                      <span>Discount</span>
                      <span>
                        {Intl.NumberFormat("en-IN").format(
                          formatPrice(invoice.discount ? invoice.discount : 0)
                        )}
                        {/* {invoice.discount ? invoice.discount : 0} */}
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : " BDT"}
                      </span>
                    </p>
                    {/* <p className="flex justify-between">
                  <span>Vat</span>
                  <span>
                    {invoice.vat ? formatPrice(invoice.vat): 0.0000}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p> */}
                    {/* <p className="flex justify-between">
                  <span>Service Charge </span>
                  <span>
                    {invoice.tax ? formatPrice(invoice.tax) : 0.0}

                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p> */}
                  </div>
                  {/* <hr></hr> */}
                  <div
                    style={{
                      borderTop: "0.5px solid #D3D3D3",
                      margin: "10px 0",
                    }}
                  ></div>

                  <div className="my-2">
                    <p className="flex justify-between">
                      <span>Grand Total</span>
                      <span>
                        {/* {formatPrice(invoiceCalculate(invoice).grandTotal)} */}
                        {
                          // Ensure values are valid numbers and calculate before toFixed
                          Intl.NumberFormat("en-IN").format(
                            Number.parseFloat(
                              (
                                (Number(totalPricePrint) || 0) +
                                (Number(invoice?.vat) || 0) +
                                (Number(invoice?.tax) || 0) +
                                (Number(invoice?.delivery_fee) || 0) -
                                (Number(invoice?.discount) || 0)
                              ).toFixed(2)
                            ).toFixed(2)
                          )
                        }
                        {/* {invoice.sub_total} */}
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : " BDT"}
                      </span>
                    </p>
                    {/* <p className="flex justify-between">
                      <span>Paid Amount</span>
                      <span>

                        {formatPrice(invoice.paid_amount)}
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : " BDT"}
                      </span>
                    </p> */}

                      {/* Show individual multiple payments if available */}
                      {/*                   */}
                      {invoice?.multiple_payment?.length > 0 &&
                        invoice.multiple_payment.map((payment, index) => (
                          <p key={index} className="flex justify-between">
                            <span className="pl-5">
                              {payment.payment_type?.type_name ||
                                payment.payment_type_category?.[0]?.payment_category_name ||
                                "Unknown"}{" "}
                              Payment{" "}
                              {payment.invoice_id?.includes("INV-DUE") && (
                                <span className="text-[10px] text-gray-500">(Due Payment)</span>
                              )}
                            </span>

                            <span>
                              {Intl.NumberFormat("en-IN").format(payment.payment_amount)}{" "}
                              {invoiceSetting?.currency_info?.code || "BDT"}
                            </span>
                          </p>
                        ))}

                    <p className="flex justify-between">
                      <span>Paid Amount</span>
                      <span>
                        {(() => {
                          const totalExchangePrice =
                            exChangeImeis?.reduce(
                              (acc, item) => acc + (item.purchase_price || 0),
                              0
                            ) || 0;

                          const adjustedPaidAmount =
                            invoice.paid_amount && invoice.paid_amount !== ""
                              ? invoice.paid_amount
                              : 0;

                          return (
                            Intl.NumberFormat("en-IN").format(
                              formatPrice(adjustedPaidAmount)
                            ) + (invoiceSetting?.currency_info?.code || " BDT")
                          );
                        })()}
                      </span>
                    </p>
                  </div>
                  {/* <hr></hr> */}
                  <div
                    style={{
                      borderTop: "0.5px solid #D3D3D3",
                      margin: "10px 0",
                    }}
                  ></div>
                  <p className="flex justify-between mt-2">
                    <span>Due Amount</span>
                    <span>
                      {Number.parseFloat(
                        Number(totalPricePrint) +
                          Number(invoice?.vat) +
                          Number(invoice?.tax) +
                          Number(invoice?.delivery_fee) -
                          Number(invoice?.discount) -
                          Number(
                            invoice.paid_amount && invoice.paid_amount !== ""
                              ? invoice.paid_amount
                              : 0
                          ) - totalDuePayment
                      ).toFixed(2) < 0
                        ? 0
                        : Intl.NumberFormat("en-IN").format(
                            Number.parseFloat(
                              Number(totalPricePrint) +
                                Number(invoice?.vat) +
                                Number(invoice?.tax) +
                                Number(invoice?.delivery_fee) -
                                Number(invoice?.discount) -
                                Number(
                                  invoice.paid_amount &&
                                    invoice.paid_amount !== ""
                                    ? invoice.paid_amount
                                    : 0
                                ) - totalDuePayment
                            ).toFixed(2)
                          )}
                      {invoiceSetting?.currency_info?.code
                        ? invoiceSetting?.currency_info?.code
                        : " BDT"}
                    </span>
                  </p>
                </div>
              </div>
              {/* amount in words */}
              <p className="text-gray-900 mt-4 font-nunito text-xs  lg:text-base font-semibold leading-normal text-center">
                <span style={{ color: "#A0AEC0" }}>In Word:</span>{" "}
                {numberToWords(
                  formatPrice(invoiceCalculate(invoice).grandTotal)
                )}{" "}
                taka only
              </p>
              {/* <div style={{ ...styles.div }}>
              <p className="text-white font-nunito text-xs font-bold">
                You saved {formatPrice(invoice.discount ? invoice.discount : 0)}
                {invoiceSetting?.currency_info?.code
                  ? invoiceSetting?.currency_info?.code
                  : " BDT"}{" "}
                in this purchase{" "}
              </p>
            </div> */}
              <div
                style={
                  invoiceSetting?.dummy_text
                    ? {
                        backgroundColor: invoiceSetting?.dummy_text,
                        color: "white",
                        WebkitPrintColorAdjust: "exact",
                        padding: "10px 10px 10px 10px",
                        textAlign: "center",
                        margin: "13px 0px 10px 0px",
                      }
                    : { ...styles.div }
                }
              >
                <p className="text-white font-nunito text-sm font-bold">
                  You saved{" "}
                  {Intl.NumberFormat("en-IN").format(
                    formatPrice(invoice.discount ? invoice.discount : 0)
                  )}
                  {/* You saved {invoice.discount ? invoice.discount : 0} */}
                  {invoiceSetting?.currency_info?.code
                    ? invoiceSetting?.currency_info?.code
                    : " BDT"}{" "}
                  in this purchase{" "}
                </p>
              </div>
              {/* web address qr code */}
              <QRCode
                className="w-[50px] object-contain p-0 mt-2"
                value={
                  invoice?.user_info?.web_address ||
                  invoice?.user_info?.invoice_settings?.web_address ||
                  "No Web Address set to the QR code"
                }
                size={50}
              />
              {/* signature */}
              {/* <div className="text-xs md:text-sm lg:text-base">
            <div className="flex justify-between">
              {invoiceSetting?.sign_authority && (
              <div className="w-[100px] h-[30px] rounded-lg">
              </div>
            )}
              <div className="w-[100px] h-[30px] rounded-lg">
              </div>
            </div>
            <div className="flex justify-between m-2">
              <p>
                <hr></hr> Customer Signature
              </p>
              <p>
                <hr></hr> Seller Signature{" "}
              </p>
            </div>
          </div> */}
              {/* <div className="text-xs md:text-sm lg:text-base">
            <div className="flex justify-end">
              {invoiceSetting?.sign_authority && (
                <div className="w-[100px] h-[30px] rounded-lg"></div>
              )}
              <div className="w-[100px] h-[30px] rounded-lg"></div>
            </div>
            <div className="flex justify-end items-center m-2">
              <div className="flex flex-col items-center border-t border-gray-300">
                <hr className="w-full" />
                <span>Authorized Signature</span>
              </div>
            </div>
          </div> */}
              {/* terms and conditions */}
              {/* <div class="w-1/2 p-4">
            <h3 class="text-xs font-semibold text-gray-800 mb-2">Terms and Conditions</h3>
            <ul class="list-disc list-inside text-gray-700 text-xs">
                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                <li>Nulla facilisi. Suspendisse potenti.</li>
                <li>Mauris ut metus non nisl pulvinar cursus.</li>
            </ul>
          </div> */}
              {/* Terms and Conditions Section */} {/* Signature Section */}
              <div className="flex space-x-5 text-[10px] lg:text-sm mt-2">
                <div className=" pt-2 w-1/2 ">
                  <h3 className="text-[16px] font-semibold text-gray-800 mb-2">
                    Terms and Conditions
                  </h3>
                  <ul className="list-disc list-inside text-gray-700 text-[14px]">
                    {/* <li>All prices include taxes. Payment must be made in full at the time of purchase via accepted payment methods.</li>
                  <li>Disputes will be resolved under the laws of Bangladesh.</li>
                  <li>Defective or incorrect items will be replaced or refunded at no additional cost.</li> */}
                    {inputs.map((item, index) => (
                      <li className="text-[14px]" key={item.id || index}>{item.description}</li>
                    ))}
                  </ul>
                </div>
                {/* signature */}
                <div className="p-4 text-xs flex flex-col items-end w-1/2 ">
                  {/* <div className="flex justify-end">
                {invoiceSetting?.sign_authority && (
                  <div className="w-[100px] h-[30px] rounded-lg"></div>
                )}
                <div className="w-[100px] h-[30px] rounded-lg"></div>
              </div> */}
                  <div className="flex flex-col justify-end items-center">
                    <div className="border-t border-gray-300 mt-16">
                      <p className="">Customer Signature</p>
                    </div>
                    <div className="flex flex-col items-center border-t border-gray-300 mt-20">
                      <hr className="w-full" />
                      <span>Authorized Signature</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* footer */}
              <div className="text-center font-nunito mt-10 text-xs md:text-sm lg:text-base">
                <h2 className="text-orange-500  text-xs font-semibold ">
                  Thanks for purchase
                </h2>
                {/* <p className="text-black mt-2 text-xs">
              A Product of {invoice?.user_info?.invoice_settings?.shop_name}{" "}
              </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* this is the Pad print  download file */}
      <PdfHtmlContentPad
        invoice={invoice}
        invoiceSetting={invoiceSetting}
        invoiceImeis={invoiceImeis}
        inputs={inputs}
        formattedDateTime={formattedDateTime}
        totalPricePrintPad={totalPricePrintPad}
        totalItemsPrintPad={totalItemsPrintPad}
        styles={styles}
        totalPrice={totalPrice}
        totalQty={totalQty}
        exChangeImeis={exChangeImeis}
      />

      <PdfHtmlContentPadCustomize
        invoice={invoice}
        invoiceSetting={invoiceSetting}
        invoiceImeis={invoiceImeis}
        inputs={inputs}
        formattedDateTime={formattedDateTime}
        totalPricePrintPad={totalPricePrintPad}
        totalItemsPrintPad={totalItemsPrintPad}
        styles={styles}
        totalPrice={totalPrice}
        totalQty={totalQty}
        exChangeImeis={exChangeImeis}
      />
      <PdfHtmlContentCustomize
        invoice={invoice}
        invoiceSetting={invoiceSetting}
        invoiceImeis={invoiceImeis}
        inputs={inputs}
        formattedDateTime={formattedDateTime}
        totalPricePrintCustomize={totalPricePrintCustomize}
        totalItemsPrintCustomize={totalItemsPrintCustomize}
        styles={styles}
        totalPrice={totalPrice}
        totalQty={totalQty}
        BASE_URL={BASE_URL}
        exChangeImeis={exChangeImeis}
      />
      <PdfHtmlContentCustomizeWithoutColor
        invoice={invoice}
        invoiceSetting={invoiceSetting}
        invoiceImeis={invoiceImeis}
        inputs={inputs}
        formattedDateTime={formattedDateTime}
        totalPricePrintCustomize={totalPricePrintCustomize}
        totalItemsPrintCustomize={totalItemsPrintCustomize}
        styles={styles}
        totalPrice={totalPrice}
        totalQty={totalQty}
        BASE_URL={BASE_URL}
        exChangeImeis={exChangeImeis}
      />
      <PdfHtmlContentBrandNew
        invoice={invoice}
        invoiceSetting={invoiceSetting}
        invoiceImeis={invoiceImeis}
        inputs={inputs}
        formattedDateTime={formattedDateTime}
        totalPricePrintCustomize={totalPricePrintCustomize}
        totalItemsPrintCustomize={totalItemsPrintCustomize}
        styles={styles}
        totalPrice={totalPrice}
        totalQty={totalQty}
        BASE_URL={BASE_URL}
        exChangeImeis={exChangeImeis}
      />
      <PdfHtmlContentToken
        invoice={invoice}
        invoiceSetting={invoiceSetting}
        invoiceImeis={invoiceImeis}
        inputs={inputs}
        formattedDateTime={formattedDateTime}
        totalPricePrintCustomize={totalPricePrintCustomize}
        totalItemsPrintCustomize={totalItemsPrintCustomize}
        styles={styles}
        totalPrice={totalPrice}
        totalQty={totalQty}
        BASE_URL={BASE_URL}
        exChangeImeis={exChangeImeis}
      />
    </>
  );
};

const styles = {
  div: {
    backgroundColor: "#407BFF",
    color: "white",
    WebkitPrintColorAdjust: "exact",
    padding: "10px 10px 10px 10px",
    textAlign: "center",
    margin: "13px 0px 10px 0px",
  },
  paymentMethodDiv: {
    transform: "rotate(-45deg)",
    padding: "10px",
    textAlign: "center",
    // backgroundColor: '#407BFF',
    color: "black",
    // WebkitPrintColorAdjust: 'exact',
    margin: "30px 30px 20px 180px",
    maxWidth: "120px",
    wordWrap: "break-word",
    overflow: "hidden",
    fontSize: "13px",

    // border: '2px solid #407BFF',
    // borderRadius: '50%',
    // width: '180px',
    // height: '120px',
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
  },
  paymentMethodPrintDiv: {
    transform: "rotate(-45deg)",
    padding: "10px",
    textAlign: "center",
    // backgroundColor: '#407BFF',
    color: "black",
    // WebkitPrintColorAdjust: 'exact',
    margin: "30px 30px 20px 180px",
    maxWidth: "120px",
    wordWrap: "break-word",
    overflow: "hidden",
    fontSize: "10px",

    // border: '2px solid #407BFF',
    // borderRadius: '50%',
    // width: '120px',
    // height: '120px',
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
  },
};

export default PdfHtmlContent;
